<div class="d-flex">
  <!-- VAMOS A VALIDAR TODOS LOS SWITCH DEPENDIENDO sensors_hydro  -->
  <div
    class="w-100 d-flex align-items-center justify-content-between px-3 pb-3"
    *ngIf="option_selected === 'Sensores'"
  >
    <div class="container-body w-100 mb-3 mt-2 ml-4 mr-4 d-flex justify-content-around">
      <h4 class="mb-0">{{ "clients.sensors.title" | translate }}</h4>
      <div class="center">
        <div class="d-flex justify-content-around align-items-center mr-3">
          <app-loading-status [status]="loading_sensors"></app-loading-status>

          <div class="d-flex justify-content-end align-items-center ml-2">
            <div class="form-check p-0">
              <label class="switch m-0">
                <input
                  type="checkbox"
                  [value]="enabledDisabledSensed"
                  [checked]="enabledDisabledSensed"
                  (change)="changeEnabledDisabled(enabledDisabledSensed)"
                />
                <span class="slider round"></span>
              </label>
            </div>
          </div>
        </div>
        <button class="btn btn-secondary" (click)="goSensors(device)">
          <app-image-color
            [height]="'16px'"
            [width]="'25px'"
            [url]="'menu-icons/parametrias.svg'"
            [color]="'#ffffff'"
          ></app-image-color>
        </button>
      </div>
    </div>
  </div>
</div>

<ng-container [ngSwitch]="option_selected">
  <ng-container *ngSwitchCase="'Tolva'">
    <div class="center h-100">
      <view-virtual-weight class="w-100 h-100" [feeder]="device"></view-virtual-weight>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'Velocidad'">
    <app-speed-view-feeder
      [feeder]="device"
      class="center flex-column"
      [speed_bar]="speed_bar"
      [view_old_title]="view_old_title_speed"
    ></app-speed-view-feeder>
  </ng-container>
  <ng-container *ngSwitchCase="'Sensores'">
    <div class="px-3 pb-3">
      <app-sensors-value
        [data]="device"
        [type]="'individual'"
        [enabled]="enabledDisabledSensed"
      ></app-sensors-value>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'Config'">
    <div>
      <app-settings-feeders [feeder]="device"></app-settings-feeders>
    </div>
  </ng-container>

  <ng-container *ngSwitchDefault></ng-container>
</ng-container>
